/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react'
import GridResult from './GridResult'
import { classNames } from 'helpers/utilities'
import type { NfdRecord } from 'api/api-client'

interface ManageResultsGridProps {
  results: NfdRecord[]
  walletAddress: string
}

export default function ManageResultsGrid({ results, walletAddress }: ManageResultsGridProps) {
  const [shouldFixMaxWidth, setShouldFixMaxWidth] = useState(true)

  useEffect(() => {
    const handleResize = () => {
      if (!results) return

      const isXlScreen = window.matchMedia('(min-width: 1280px)').matches
      const numResults = results.length

      if (isXlScreen && numResults > 0) {
        const sidebarWidth = 256
        const mainWidth = window.innerWidth - sidebarWidth
        const paddingX = 64 // pl + pr
        const gridGapX = 32
        const maxItemWidth = 280

        const availableSpace = mainWidth - paddingX - gridGapX * (numResults - 1)
        const shouldSetFixedMaxWidth = availableSpace / numResults > maxItemWidth

        setShouldFixMaxWidth(shouldSetFixedMaxWidth)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [results])

  const gridClasses = classNames(
    shouldFixMaxWidth
      ? 'xl:grid-cols-[repeat(auto-fit,_minmax(240px,_280px))]'
      : 'xl:grid-cols-[repeat(auto-fit,_minmax(240px,_1fr))]',
    'space-y-4 md:space-y-0 md:grid md:grid-cols-3 md:gap-y-10 md:gap-x-6 xl:gap-x-8'
  )

  return (
    <div className={gridClasses}>
      {results.map((nfd) => (
        <GridResult key={nfd.name} nfd={nfd} walletAddress={walletAddress} />
      ))}
    </div>
  )
}
